export default "__VITE_ASSET__cPnqwbkZ__"